import BaseService from "./base.service";

export default class CustomerCommentService extends BaseService {
    constructor(ctx) {
        super(ctx)
    }

    getCustomerCommentHome = (query) => {
        return this.get('/comment', query)
    }

    getCustomerCommentByUser = (query) => {
        return this.get('/comment/user', query)
    }

    getCommentByBusiness = (query) => {
        return this.get('/comment/by-business', query)
    }

    getCommentByDepartment = (query) => {
        return this.get('/comment/by-department', query)
    }
}